import { render, staticRenderFns } from "./PrimerInforme.vue?vue&type=template&id=bb533ea0&"
import script from "./PrimerInforme.vue?vue&type=script&lang=js&"
export * from "./PrimerInforme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports